<template>
    <nav class="navbar navbar-expand-lg">
        <!-- Logo et titre -->
        <a class="navbar-brand" href="#">
            <div class="d-flex align-items-center">
                <!-- <img src="@/assets/logo1.png" alt="logo" class="ml-3" style="width: 50px;"> -->
                <h3 class="text-dark">
                    ESPACE <span class="font-weight-bold">YAM'S</span>
                </h3>
            </div>
        </a>

        <!-- Boutons de notification et profile - visibles seulement en desktop -->
        <div class="desktop-nav-actions d-none d-lg-flex ml-auto">
            <!-- Bouton notifications -->
            <div class="nav-action-btn" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Notifications"
                @click="openNotificationsModal">
                <i class="far fa-bell"></i>
                <span v-if="notificationCount > 0" class="notification-badge">{{ notificationCount }}</span>
            </div>

            <!-- Profile dropdown -->
            <div class="profile-section">
                <div class="profile-dropdown-toggle" @click="toggleProfileDropdown">
                    <div class="chevron-icon">
                        <i :class="['fas', isProfileDropdownOpen ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
                    </div>
                    <div class="profile-name">{{ userName }}</div>
                    <div class="profile-img">
                        <img :src="userPhoto" class="rounded-circle" alt="Photo de profil">
                    </div>
                </div>

                <!-- Profile dropdown menu -->
                <div class="profile-dropdown" :class="{ 'show': isProfileDropdownOpen }">
                    <a class="dropdown-item" href="#" @click.prevent="openProfileModal">
                        <i class="fa-regular fa-user"></i>
                        Profil
                        <img :src="userPhoto" class="rounded-circle ml-auto" width="25px">
                    </a>
                    <a class="dropdown-item logout" href="#" @click.prevent="logout">
                        <i class="fa-solid fa-arrow-right-from-bracket"></i>
                        Se déconnecter
                    </a>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import { defineComponent, defineAsyncComponent } from 'vue';
import { mapGetters, mapActions } from 'vuex';
const NotificationComponent = defineAsyncComponent(() => import('@/components/NotificationComponent.vue'));
const MyProfile = defineAsyncComponent(() => import('@/auth/MyProfile.vue'));

export default defineComponent({
    name: 'NavBar',
    data() {
        return {
            isProfileDropdownOpen: false
        }
    },
    computed: {
        ...mapGetters(['notificationCount']),
        userName() {
            return this.$store.getters.user?.nom || '';
        },
        userPhoto() {
            return this.$store.getters.user?.photo || '';
        }
    },
    mounted() {
        // Ferme le dropdown si on clique à l'extérieur
        document.addEventListener('click', this.closeDropdownOnClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.closeDropdownOnClickOutside);
    },
    methods: {
        ...mapActions(['stopFetchingNotifications']),
        openNotificationsModal() {
            this.$dialog.open(NotificationComponent, {
                props: {
                    header: "Notifications",
                    style: {
                        width: '50vw'
                    },
                    modal: true
                },
            });
        },
        openProfileModal() {
            this.$dialog.open(MyProfile, {
                props: {
                    header: "Mon compte",
                    style: {
                        width: '40vw'
                    },
                    modal: true
                },
            });
            this.isProfileDropdownOpen = false;
        },
        toggleProfileDropdown(event) {
            event.stopPropagation();
            this.isProfileDropdownOpen = !this.isProfileDropdownOpen;
        },
        closeDropdownOnClickOutside(event) {
            const profileSection = document.querySelector('.navbar .profile-section');
            if (this.isProfileDropdownOpen &&
                profileSection &&
                !profileSection.contains(event.target)) {
                this.isProfileDropdownOpen = false;
            }
        },
        logout() {
            this.$router.push({ name: 'login' });
            this.$store.commit('clearUserData');
            this.stopFetchingNotifications();

            this.axios.post('/api/logout').then(response => {
                if (response.data.success === true) {
                    this.$toast.add({
                        severity: 'success',
                        detail: response.data.message,
                        life: 3000
                    });
                } else {
                    response.data.errors.forEach(element => {
                        this.$toast.error(element, {
                            duration: '8000',
                            position: 'top-left'
                        });
                    });
                }
            }).catch(() => {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            });
        }
    }
})
</script>

<style scoped>
.navbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 1rem;
    background-color: #fff;
}

.navbar-brand {
    display: flex;
    align-items: center;
    text-decoration: none;
}

/* Séparateur slash */
.header-separator {
    font-size: 1.5rem;
    font-weight: 300;
    color: #6c757d;
}

/* Conteneur pour le slot header */
.header-contentys {
    font-size: 1.2rem;
}

/* Boutons de navigation desktop */
.desktop-nav-actions {
    display: flex;
    align-items: center;
}

/* Bouton notification */
.nav-action-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 16px;
    cursor: pointer;
    color: #6c757d;
    position: relative;
    transition: all 0.3s ease;
    background-color: #f8f9fa;
}

.nav-action-btn:hover {
    background-color: rgba(0, 123, 255, 0.1);
    color: #007bff;
}

.nav-action-btn i {
    font-size: 1.2rem;
}

/* Badge de notification */
.notification-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    background-color: #dc3545;
    color: white;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    font-size: 0.7rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Section profil - style selon la maquette */
.profile-section {
    position: relative;
}

.profile-dropdown-toggle {
    display: flex;
    align-items: center;
    padding: 4px 12px 4px 8px;
    background-color: #f8f9fa;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.profile-dropdown-toggle:hover {
    background-color: #f1f3f5;
}

.chevron-icon {
    font-size: 0.6rem;
    margin-right: 8px;
    color: #495057;
}

.profile-name {
    font-size: 0.9rem;
    font-weight: 500;
    color: #495057;
    margin-right: 8px;
    white-space: nowrap;
}

.profile-img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
}

.profile-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* Menu dropdown du profil - style adapté à la maquette */
.profile-dropdown {
    position: absolute;
    right: 0;
    top: calc(100% + 6px);
    width: 240px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
    opacity: 0;
    visibility: hidden;
    transform: translateY(-10px);
    transition: all 0.2s ease;
    z-index: 1000;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.05);
}

.profile-dropdown.show {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
}

.dropdown-item {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    color: #343a40;
    text-decoration: none;
    transition: background-color 0.15s ease;
}

.dropdown-item:hover {
    background-color: #f8f9fa;
}

.dropdown-item i {
    margin-right: 12px;
    font-size: 1rem;
    color: #6c757d;
    width: 16px;
    text-align: center;
}

.dropdown-item.logout {
    color: #dc3545;
    border-top: 1px solid #f1f3f5;
}

.dropdown-item.logout i {
    color: #dc3545;
}

/* Adaptation pour mobile */
@media (max-width: 768px) {
    .header-contentys {
        font-size: 1rem;
    }

    .header-separator {
        font-size: 1.2rem;
    }
}
</style>